<template>
	<div class="right-control">
		<el-popover
			class="popover"
			placement="left"
			title="限制设定"
			width="400"
			trigger="click"
			@show="showPopover"
		>
			<div class="right">
				<div class="item" v-for="item in rightControlList" :key="item.id">
					<div class="name">{{ item.name }}</div>
					<div class="switch">
						<el-switch
							v-model="item.flagEnable"
							active-color="#409eff"
							inactive-color="#dcdfe6"
							@change="switchChange(item)"
						>
						</el-switch>
					</div>
				</div>
			</div>
			<ig-icon slot="reference" name="brush"></ig-icon>
		</el-popover>
	</div>
</template>

<script>
import setmeal from '@/backend/services/account/setmeal.js';
export default {
	name: 'messageSwitch',
	props: {
		tableData: Object,
		scope: Object,
	},
	data() {
		return {
			rightControlList: [],
		};
	},
	methods: {
		async showPopover() {
			this.rightControlList = [];
			let res = await setmeal.featureDetail(this.scope.row.functionItemVersionId);
			console.log(res.data);
			let { taskFlowFlag, addFlag, isAllowRenewal, changeFlag, selfPlaceOrderFlag, superpositionFlag } = res.data;
			this.rightControlList = [
				{ name: '是否选择任务流', flagEnable: taskFlowFlag, type: 'TASK_FLOW_FLAG' },
				{ name: '允许新增', flagEnable: addFlag, type: 'ADD_FLAG' },
				{ name: '允许续费', flagEnable: isAllowRenewal, type: 'IS_ALLOW_RENEWAL' },
				{ name: '允许变更', flagEnable: changeFlag, type: 'CHANGE_FLAG' },
				{ name: '允许客户自主下单', flagEnable: selfPlaceOrderFlag, type: 'SELF_PLACE_ORDER_FLAG' },
				{ name: '允许叠加', flagEnable: superpositionFlag, type: 'SUPERPOSITION_FLAG'}
			];
		},
		async switchChange(item) {
			try {
				let params = {
					id: this.scope.row.id,
				};
				let bodyParam = {
					functionSwitchEnum: item.type,
				};
				 await setmeal.setRenew(params, bodyParam);
                this.$message.success('设置成功');
			} catch (error) {
                this.$message.success('设置失败');
            }

			
		},
	},
};
</script>

<style lang="scss" scoped>
.right-control {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;

	.popover {
		margin: 0 20px;

		.iconfont {
			font-size: 18px;
		}
	}
}

.right {
	padding: 10px 0;
	padding-left: 20px;

	.item {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.name,
		.date,
		.switch {
			flex: 1;
			// 单行溢出
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.name {
			text-align: left;
		}

		.date {
			text-align: center;
		}

		.switch {
			text-align: right;
		}
	}
}
</style>
